export default {
  postOffice: {}
}



// WEBPACK FOOTER //
// ./src/components/postOffice/store/state.js